/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module CportalModule */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    CportalService,
    CPORTAL_SERVICE_TOKEN,
} from './services';

import {
    PortalInfo,
    PORTAL_INFO_ITEM_TOKEN,
} from './factories';

const cportalModule = angular.module('avi/cportal');

const services = [
    {
        dependency: CportalService,
        name: CPORTAL_SERVICE_TOKEN,
    },
];

const factories = [
    {
        factory: PortalInfo,
        name: PORTAL_INFO_ITEM_TOKEN,
    },
];

services.forEach(({ name, dependency }) => {
    initAjsDependency(cportalModule, 'service', name, dependency);
});

factories.forEach(({ name, factory }) => {
    initAjsDependency(
        cportalModule,
        'factory',
        name,
        factory,
    );
});
